import React, { useState } from "react";
import axios from "axios";
import "./CaseStudy2.css";
import pdfIcon from "../../assest/About/case-study.png";
import case1 from "../../assest/case study/Delhivery.pdf";
import case2 from "../../assest/case study/Grab.pdf";
import case3 from "../../assest/case study/The Travelport.pdf";

const CaseStudy2 = () => {
  const [selectedCase, setSelectedCase] = useState(null);
  const [modalVisible, setModalVisible] = useState(false);
  const [, setDownloadReady] = useState(false);
  const [formData, setFormData] = useState({
    name: "",
    position: "",
    company: "",
    phone: "",
    email: "",
  });

  const cases = [
    { id: 1, title: "Delhivery", pdf: case1 },
    { id: 2, title: "Grab", pdf: case2 },
    { id: 3, title: "The Travelport", pdf: case3 },
  ];

  const handleCaseClick = (caseItem) => {
    setSelectedCase(caseItem);
    setModalVisible(true);
    setDownloadReady(false);
    resetForm();
  };

  const resetForm = () => {
    setFormData({
      name: "",
      position: "",
      company: "",
      phone: "",
      email: "",
    });
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const downloadPdf = (pdfUrl) => {
    const link = document.createElement("a");
    link.href = pdfUrl;
    link.download = `${selectedCase?.title}.pdf`;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const [errorMessage, setErrorMessage] = useState("");
  const [, setErrorEmailMessage] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!/^\d{10}$/.test(formData.phone)) {
      setErrorMessage("Please enter a valid 10-digit phone number.");
      return;
    } else {
      setErrorMessage("");
    }

    if (
      !/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(formData.email)
    ) {
      setErrorEmailMessage("Please enter a valid email address.");
      return;
    } else {
      setErrorEmailMessage("");
    }

    try {
      const requestData = {
        name: formData.name,
        position: formData.position,
        company: formData.company,
        phone: formData.phone,
        email: formData.email,
        case_title: selectedCase.title,
      };

      const response = await axios.post(
        "/customer/casestudy",
        requestData
      );

      if (response.status === 200) {
        setDownloadReady(true);
        setModalVisible(false);
        setTimeout(() => downloadPdf(selectedCase.pdf), 1000);
      } else {
        throw new Error("Failed to send email");
      }
    } catch (error) {
      console.error("❌ Error sending email:", error);
      alert("Failed to send email. Please try again.");
    }
  };


  const closeModal = () => {
    setModalVisible(false);
  };

  return (
    <div className="about-container2">
      <h1 className="solutions-heading">Case Studies</h1>
      <div className="case-list3">
        {cases.map((caseItem) => (
          <div
            key={caseItem.id}
            className="case-item3"
            onClick={() => handleCaseClick(caseItem)}
          >
            <div className="pdf-icon">
              <img src={pdfIcon} alt="PDF Icon" />
            </div>
            <div className="pdf-title">{caseItem.title}</div>
          </div>
        ))}
      </div>

      {modalVisible && (
        <div className="modal-overlay">
          <div className="modal-content">
            <button className="modal-close" onClick={closeModal}>
              &times;
            </button>
            <h2>Enter Your Details to Download {selectedCase?.title}</h2>
            <form onSubmit={handleSubmit}>
              <input
                type="text"
                name="name"
                placeholder="Your Name"
                value={formData.name}
                onChange={handleInputChange}
                required
              />
              <input
                type="text"
                name="position"
                placeholder="Your Position"
                value={formData.position}
                onChange={handleInputChange}
                required
              />
              <input
                type="text"
                name="company"
                placeholder="Your Company"
                value={formData.company}
                onChange={handleInputChange}
                required
              />
              <input
                type="tel"
                name="phone"
                placeholder="Your Phone Number"
                value={formData.phone}
                onChange={handleInputChange}
                maxLength="10"
                pattern="\d{10}"
                required
              />

              {errorMessage && (
                <div style={{ color: "red", fontSize: "0.9rem" }}>
                  {errorMessage}
                </div>
              )}
              <br />
              <input
                type="email"
                name="email"
                placeholder="Your Email"
                value={formData.email}
                onChange={handleInputChange}
                required
              />
              <button type="submit">Download</button>
            </form>
          </div>
        </div>
      )}
    </div>
  );
};

export default CaseStudy2;
